import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=520ed95b&scoped=true"
import script from "./NotAvailable.vue?vue&type=script&lang=ts"
export * from "./NotAvailable.vue?vue&type=script&lang=ts"
import style0 from "./NotAvailable.vue?vue&type=style&index=0&id=520ed95b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ed95b",
  null
  
)

export default component.exports